import React from "react";
import ReactMarkdown from "react-markdown";
import styled from "styled-components";

const TitanSubtitle = ({ content }) => {
  if (!content) return null;
  return (
    <Subtitle>
      <ReactMarkdown>{content}</ReactMarkdown>
    </Subtitle>
  );
};

const Subtitle = styled.div`
  p {
    color: #fff;
    font-size: 26px;
    text-align: center;

    strong {
      color: #ff8f00;
    }
  }
`;

export default TitanSubtitle;
